import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { resolveTitle } from '../stores/tagsView'

const Login = () => import('../views/Login.vue')
const AdminLayout = () => import('../layouts/AdminLayout.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const UserManage = () => import('../views/system/UserManage.vue')
const RoleManage = () => import('../views/system/RoleManage.vue')
const MenuManage = () => import('../views/system/MenuManage.vue')
const DeptManage = () => import('../views/system/DeptManage.vue')
const PostManage = () => import('../views/system/PostManage.vue')
const DictManage = () => import('../views/system/DictManage.vue')
const AnnouncementManage = () => import('../views/system/announcement/index.vue')
const OnlineUsers = () => import('../views/monitor/OnlineUsers.vue')
const ServerMonitor = () => import('../views/monitor/ServerMonitor.vue')
const CacheMonitor = () => import('../views/monitor/CacheMonitor.vue')
const DruidMonitor = () => import('../views/monitor/DruidMonitor.vue')
const BusinessCardManage = () => import('../views/content/business-card/index.vue')
const MpHomeVideoManage = () => import('../views/mp/home/video/index.vue')

const APP_TITLE = '香巴佬管理后台'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { public: true },
    },
    {
      path: '/',
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: { name: 'dashboard' } },
        { path: 'dashboard', name: 'dashboard', component: Dashboard, meta: { title: '工作台', affix: true } },
        {
          path: 'account/profile',
          name: 'account-profile',
          component: () => import('../views/account/Profile.vue'),
          meta: { title: '个人资料' },
        },
        {
          path: 'account/messages',
          name: 'account-messages',
          component: () => import('../views/account/Messages.vue'),
          meta: { title: '消息中心' },
        },
        { path: 'system/user', name: 'system-user', component: UserManage, meta: { title: '用户管理' } },
        { path: 'system/role', name: 'system-role', component: RoleManage, meta: { title: '角色管理' } },
        { path: 'system/menu', name: 'system-menu', component: MenuManage, meta: { title: '菜单管理' } },
        { path: 'system/dept', name: 'system-dept', component: DeptManage, meta: { title: '部门管理' } },
        { path: 'system/post', name: 'system-post', component: PostManage, meta: { title: '岗位管理' } },
        { path: 'system/dict', name: 'system-dict', component: DictManage, meta: { title: '字典管理' } },
        {
          path: 'system/announcement',
          name: 'system-announcement',
          component: AnnouncementManage,
          meta: { title: '公告管理' },
        },
        {
          path: 'system/dict/data/:dictType',
          name: 'system-dict-data',
          component: () => import('../views/system/DictData.vue'),
          meta: { title: '字典数据' },
        },
        { path: 'monitor/online', name: 'monitor-online', component: OnlineUsers, meta: { title: '在线用户' } },
        { path: 'monitor/server', name: 'monitor-server', component: ServerMonitor, meta: { title: '服务监控' } },
        { path: 'monitor/cache', name: 'monitor-cache', component: CacheMonitor, meta: { title: '缓存监控' } },
        { path: 'monitor/druid', name: 'monitor-druid', component: DruidMonitor, meta: { title: '连接池监控' } },
        {
          path: 'content/business-card',
          name: 'content-business-card',
          component: BusinessCardManage,
          meta: { title: '名片管理' },
        },
        {
          path: 'mp/card/template',
          name: 'mp-card-template',
          component: () => import('../views/mp/card/template/index.vue'),
          meta: { title: '名片模板' },
        },
        {
          path: 'mp/card/template/:id',
          name: 'mp-card-template-edit',
          component: () => import('../views/mp/card/template/edit.vue'),
          meta: { title: '名片模板编辑' },
        },
        {
          path: 'mp/card/company-video',
          name: 'mp-card-company-video',
          component: MpHomeVideoManage,
          meta: {
            title: '企业视频',
            videoModule: 'CARD_COMPANY',
            videoSingleton: true,
          },
        },
        {
          path: 'mp/card/factory',
          name: 'mp-card-factory',
          component: () => import('../views/mp/card/factory/index.vue'),
          meta: { title: '工厂地图' },
        },
        {
          path: 'mp/card/banner',
          name: 'mp-card-banner',
          component: () => import('../views/mp/home/item/index.vue'),
          meta: { title: '轮播图', itemModule: 'CARD_BANNER' },
        },
        {
          path: 'mp/home/splash',
          name: 'mp-home-splash',
          component: () => import('../views/mp/home/splash/index.vue'),
          meta: { title: '启动页' },
        },
        {
          path: 'mp/home/banner-video',
          name: 'mp-home-banner-video',
          component: MpHomeVideoManage,
          meta: {
            title: '首页竖屏视频',
            videoModule: 'HOME_BANNER',
            videoSingleton: false,
          },
        },
        {
          path: 'mp/home/history',
          name: 'mp-home-history',
          component: () => import('../views/mp/home/history/index.vue'),
          meta: { title: '发展历程' },
        },
        {
          path: 'mp/home/founder',
          name: 'mp-home-founder',
          component: () => import('../views/mp/home/founder/index.vue'),
          meta: { title: '创始人简介' },
        },
        {
          path: 'mp/home/tech',
          name: 'mp-home-tech',
          component: () => import('../views/mp/home/item/index.vue'),
          meta: { title: '生产技术', itemModule: 'TECH' },
        },
        {
          path: 'mp/home/outlet',
          name: 'mp-home-outlet',
          component: () => import('../views/mp/home/item/index.vue'),
          meta: { title: '终端网点', itemModule: 'OUTLET' },
        },
        {
          path: 'mp/home/party',
          name: 'mp-home-party',
          component: () => import('../views/mp/home/item/index.vue'),
          meta: { title: '党建', itemModule: 'PARTY' },
        },
        {
          path: 'mp/home/honor',
          name: 'mp-home-honor',
          component: () => import('../views/mp/home/item/index.vue'),
          meta: { title: '资质荣誉', itemModule: 'HONOR' },
        },
        {
          path: 'mp/product/series',
          name: 'mp-product-series',
          component: () => import('../views/mp/product/series/index.vue'),
          meta: { title: '产品系列' },
        },
        {
          path: 'mp/product/items',
          name: 'mp-product-items',
          component: () => import('../views/mp/product/item/index.vue'),
          meta: { title: '产品' },
        },
        {
          path: 'mp/product/items/:id',
          name: 'mp-product-detail',
          component: () => import('../views/mp/product/detail/index.vue'),
          meta: { title: '产品详情' },
        },
        {
          path: 'mp/product/tags',
          name: 'mp-product-tags',
          component: () => import('../views/mp/product/tag/index.vue'),
          meta: { title: '产品标签' },
        },
        {
          path: 'mp/store/items',
          name: 'mp-store-items',
          component: () => import('../views/mp/store/item/index.vue'),
          meta: { title: '工厂管理' },
        },
        {
          path: 'mp/store/tags',
          name: 'mp-store-tags',
          component: () => import('../views/mp/store/tag/index.vue'),
          meta: { title: '工厂标签' },
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.ensureReady()
  const needAuth = to.matched.some((r) => r.meta.requiresAuth)
  if (needAuth && !auth.token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && auth.token) {
    return { name: 'dashboard' }
  }
  return true
})

router.afterEach((to) => {
  const pageTitle = resolveTitle(to)
  document.title = pageTitle ? `${pageTitle} - ${APP_TITLE}` : APP_TITLE
})

export default router
